import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["accountId"];
import { useHubSpotterUsersForAccount } from '../playlistAssignmentsQueries';
import formatName from 'I18n/utils/formatName';
import { useEffect, useRef } from 'react';
import Raven from 'raven-js';
import { Select } from 'foundations-components/transitional/components/Select';
import { createElement as _createElement } from "react";
const PAGE_SIZE = 20;
export const HubSpotterAccountUsersSelect = _ref => {
  let {
      accountId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    usersForAccountLoading,
    refetchUsersForAccount
  } = useHubSpotterUsersForAccount({
    accountId
  });
  const accumulatedResults = useRef({});
  useEffect(() => {
    accumulatedResults.current = {};
  }, [accountId]);
  return /*#__PURE__*/_createElement(Select, Object.assign({}, props, {
    isLoading: usersForAccountLoading
    // Reset the state when the account changes and we want to load new users
    ,
    key: accountId,
    loadOptions: async (query, callback, pagination = {
      offset: 0
    }) => {
      try {
        const newUsers = await refetchUsersForAccount({
          query,
          offset: pagination.offset
        });
        const newResults = Object.assign({}, accumulatedResults.current);
        newUsers.results.forEach(user => {
          newResults[user.userId] = formatName({
            firstName: user.firstName,
            lastName: user.lastName
          }) || user.email || user.userId.toString();
        });
        accumulatedResults.current = newResults;
        const newOptions = Object.entries(newResults).map(([value, text]) => ({
          value,
          text
        }));
        callback(null, {
          options: newOptions,
          pagination: {
            hasMore: newUsers.hasMore,
            length: newUsers.total,
            offset: pagination.offset + PAGE_SIZE
          }
        });
      } catch (e) {
        Raven.captureException(e);
      }
    },
    multi: true
  }));
};